<template>
  <div class="contentbox">
    <!--采购单模版选择-->
    <div class="conten">
      <div class="personal_settings">
        <div class="title">
          <span></span>
          <span>My Account</span>
          <!--<i @click="edit_state = true" class="el-icon-edit-outline"></i>-->
          <span></span>
        </div>
        <div class="form_max_box">
          <div class="form_itme">
            <div>Area code：</div>
            <div v-show="!edit_state">{{usersInfo.users_areacode}}</div>
            <el-select v-model="usersInfo.users_areacode"
                       v-show="edit_state"
                       placeholder="請選擇區號">
              <el-option
                v-for="item in code_list"
                :key="item.region_num"
                :label="item.region_num +' ('+item.region_name+')'"
                :value="item.region_num">
              </el-option>
            </el-select>
          </div>
          <div class="form_itme">
            <div>Mobile no：</div>
            <div v-show="!edit_state">{{usersInfo.users_phone}}</div>
            <el-input v-show="edit_state" v-model="usersInfo.users_phone"></el-input>
          </div>
          <div class="form_itme">
            <div>Company name：</div>
            <div v-show="!edit_state">{{usersInfo.users_clinic}}</div>
            <el-input v-show="edit_state" v-model="usersInfo.users_clinic"></el-input>
          </div>
          <div class="form_itme">
            <div>Register account：</div>
            <div v-show="!edit_state">{{usersInfo.users_username}}</div>
            <el-input v-show="edit_state" v-model="usersInfo.users_username"></el-input>
          </div>
          <div class="form_itme">
            <div>Dentist / Lab name：</div>
            <div v-show="!edit_state">{{usersInfo.users_realname}}</div>
            <el-input v-show="edit_state" v-model="usersInfo.users_realname"></el-input>
          </div>
          <div class="form_itme">
            <div>Fax：</div>
            <div v-show="!edit_state">{{usersInfo.users_fax}}</div>
            <el-input v-show="edit_state" v-model="usersInfo.users_fax"></el-input>
          </div>
          <div class="form_itme">
            <div>Company Tel：</div>
            <div v-show="!edit_state">{{usersInfo.users_telephone}}</div>
            <el-input v-show="edit_state" v-model="usersInfo.users_telephone"></el-input>
          </div>
          <div class="form_itme">
            <div>Address：</div>
            <div class="address_box" v-show="!edit_state">{{usersInfo.users_address}}</div>
            <el-input v-show="edit_state" v-model="usersInfo.users_address"></el-input>
          </div>
          <div class="form_itme">
            <div>Email：</div>
            <div v-show="!edit_state">{{usersInfo.users_email}}</div>
            <el-input v-show="edit_state" v-model="usersInfo.users_email"></el-input>
          </div>
          <div class="form_itme">
            <div>Personal points：</div>
            <div>{{usersInfo.users_points}}</div>
          </div>
          <div class="form_itme">
            <div>state：</div>
            <div>
              {{usersInfo.users_status==='1'?'正常':'关闭'}}
            </div>
          </div>
          <div class="form_itme">
            <div>Registration time：</div>
            <div>{{usersInfo.users_addtime}}</div>
          </div>
          <div class="form_itme but_box" v-show="!edit_state">
            <el-button @click="edit_state = true" type="primary">Edit</el-button>
          </div>
          <div class="form_itme but_box" v-show="edit_state">
            <el-button @click="edit_state = false" type="primary">cancel</el-button>
            <el-button @click="on_editSaveUsers" type="primary">preservation</el-button>
          </div>
          <div class="address_list_box">
            <div class="address_list_itme title">
              <div>Area</div>
              <div class="address_box">Address</div>
              <div>Contact person</div>
              <div>Company Tel</div>
              <div class="add" @click="show_add_box = true">+</div>
            </div>
            <div class="address_list_itme" v-for="(itme,index) in address_list" :key="index">
              <div>{{itme.scompany_name}}</div>
              <div class="address_box">{{itme.scompany_address}}</div>
              <div>{{itme.scompany_customer}}</div>
              <div>{{itme.scompany_phone}}</div>
              <div></div>
            </div>
            <div class="address_list_itme add_itme" v-show="show_add_box">
              <div>
                <el-input v-model="add_subsidiaries_data.scompany_name"></el-input>
              </div>
              <div class="address_box">
                <el-input v-model="add_subsidiaries_data.scompany_address"></el-input>
              </div>
              <div>
                <el-input v-model="add_subsidiaries_data.scompany_customer"></el-input>
              </div>
              <div>
                <el-input v-model="add_subsidiaries_data.scompany_phone"></el-input>
              </div>
              <div>
                <el-button @click="add_subsidiaries" type="primary">Confirm new</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {MessageBox, Button, Toast} from 'mint-ui';
  import {
    getusersInfg,
    getCode,
    editSaveUsers,
    getSubCompany,
    addSubcompany,
  } from '../../assets/js/api'

  export default {
    name: "orderlist",
    data() {
      return {
        usersInfo: {}, //用戶信息
        edit_state: false, //編輯狀態
        code_list: [], //區號
        address_list: [], //子公司
        add_subsidiaries_data:{     //新增的子公司數據
          scompany_name : '',
          scompany_address : '',
          scompany_customer : '',
          scompany_phone : '',
        },
        show_add_box:false
      }
    },
    components: {
      MessageBox,
      Button,
      Toast,
    },
    mounted() {

      // 获取员工（用户）信息
      getusersInfg().then(data => {
        this.usersInfo = data.data
      })

      //獲取區號
      getCode().then((data) => {
        for (let time in data) {
          if (data[time].region_num) {
            this.code_list.push(data[time])
          }
        }
      })

      //子公司資料
      getSubCompany().then(data=>{
        if (data.status && data.data){
          this.address_list = data.data
        }
      })
    },
    methods: {
      // 增加子公司
      add_subsidiaries(){
        addSubcompany(this.add_subsidiaries_data).then(data=>{
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: data.msg,
            }).then(() => {
            });
          }
          else {
            this.$alert(data.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
          if (data.status){
            // 清除數據
            this.add_subsidiaries_data.scompany_name = ''
            this.add_subsidiaries_data.scompany_address = ''
            this.add_subsidiaries_data.scompany_customer = ''
            this.add_subsidiaries_data.scompany_phone = ''
            this.show_add_box = false
            getSubCompany().then(data=>{
              if (data.status && data.data){
                this.address_list = data.data
              }
            })
          }
        })
      },
      on_editSaveUsers() {
        editSaveUsers(this.usersInfo).then(data => {
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: data.message,
            }).then(() => {
              this.edit_state = false
            });
          }
          else {
            this.$alert(data.message, '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.edit_state = false
              }
            });
          }
        })
      }
      ,
    },
    destroyed() {//离开该页面需要移除这个监听的事件
      window.removeEventListener('scroll', this.handleScroll)
    }
    ,
  }
</script>

<style lang="less" scoped>
  @import "../../assets/less/base";

  html, body, #app {
    height: 100%;
  }

  .contentbox {
    background-color: #f2f2f2;
    width: 100%;
    .conten {
      margin-top: 52px;
      .personal_settings {
        padding: 20px;
        background: #fff;
        .title {
          text-align: center;
          font-size: 26px;
          margin: 30px auto;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          width: 80%;
          @media (min-width: @screen-xs-max) {
            width: 30%;
          }
          i {
            font-size: 20px;
            cursor: pointer;
          }

        }
        .form_max_box {
          .form_itme {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 20px auto;
            width: 80%;
            @media (min-width: @screen-xs-max) {
              width: 30%;
            }
            .address_box{
              width: 80%;
              line-height: 20px;
              white-space: pre-wrap;
              word-wrap: break-word;
            }
            &.but_box {
              justify-content: space-around;
              margin-top: 50px;
            }
            .el-input {
              width: 50%;
            }
          }
          .address_list_box{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            margin: 30px auto;
            width: 100%;
            .address_list_itme{
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 20px;
              &.title{
                font-weight: bold;
                font-size: 20px;
              }
              >div{
                width: 12%;
                text-align: center;
                &.address_box{
                  width: 30%;
                  line-height: 20px;
                }
                /deep/ input{
                  text-align: center;
                }
                &.add{
                  font-size: 26px;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/orderlist_child/my_account.vue